export const FormatDate = data => {
  // Split manually
  const [year, month, day] = data.split('-');
  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
};

// export const FormatDate = data => {
//   if (!data) return '';
//   console.log('data', data);
//   const [year, month, day] = data.split('T')[0].split('-');
//   return `${day}/${month}/${year}`;
// };
// export const FormatTime = data => {
//   var date = new Date(data);
//   // const hours = date.getHours().toString().padStart(2, '0');
//   // const minutes = date.getMinutes().toString().padStart(2, '0');
//   // Convert to HH:mm in local time
//   const time = date.toLocaleTimeString('es-MX', {
//     hour: '2-digit',
//     minute: '2-digit',
//     hour12: false
//   });
//   return time;
// };

export const FormatDateStr = data => {
  if (!data) return '';
  var options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };

  return data.toLocaleDateString('es-ES', options);
};

export const isNullOrEmpty = val => val == null || val === '';

// export const FormatDateFull = data => {
//   if (!data) return '';
//   const formatted = new Date(data).toLocaleString('es-ES', {
//     day: '2-digit',
//     month: '2-digit',
//     year: 'numeric',
//     hour: '2-digit',
//     minute: '2-digit',
//     second: '2-digit',
//     hour12: false, // 24-hour format
//     timeZone: 'America/Mexico_City' // optional, for correct local time
//   });

//   return formatted;
// };

export const FormatDateFull = data => {
  if (!data) return '-';
  if (data.includes('T')) {
    let [year, month, day] = data.split('T')[0].split('-');
    let [hr, mm] = data.split('T')[1].split(':');

    return day + '/' + month + '/' + year + ' ' + hr + ':' + mm;
  } else {
    var date = new Date(data);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var dt = date.getDate();
    var hr = date.getHours();
    var mm = date.getMinutes();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }
    if (hr < 10) {
      hr = '0' + hr;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return dt + '/' + month + '/' + year + ' ' + hr + ':' + mm;
  }
};
export const FormatTime = data => {
  if (!data) return '';

  const timePart = data.includes('T') ? data.split('T')[1] : data.split(' ')[1]; // "09:30:00.000Z"
  const [hour, minute] = timePart.split(':');

  return `${hour}:${minute}`;
};

export const FormatDateToDb = data => {
  var date = new Date(data);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var dt = date.getDate();

  if (dt < 10) {
    dt = '0' + dt;
  }
  if (month < 10) {
    month = '0' + month;
  }

  return year + '/' + month + '/' + dt;
};

export const FormatDateAndTimeToDb = data => {
  var date = new Date(data);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var dt = date.getDate();
  var hours = date.getHours();
  var minutes = date.getMinutes();

  month = month.toString().padStart(2, '0');
  dt = dt.toString().padStart(2, '0');
  hours = hours.toString().padStart(2, '0');
  minutes = minutes.toString().padStart(2, '0');
  return year + '/' + month + '/' + dt + ' ' + hours + ':' + minutes;
};

export const FormatCurrency = data => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return '$' + formatter.format(data);
};

export const IsNumber = value => {
  return typeof value === 'number'
    ? Number.isFinite(value)
    : typeof value === 'string' && value.trim() !== '' && !isNaN(value);
};

export const isJson = str => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
